import {getCroppedImgFile} from './imageUtil.ts';

export * from './videoUtil.ts';

export const getVideoDurationInBrowser = async (
  options: {file: Blob; url?: never} | {file?: never; url: string}
): Promise<number> => {
  const {file, url: urlParam} = options;
  const url = file ? URL.createObjectURL(file) : urlParam;
  const video = document.createElement('video');
  video.preload = 'metadata';
  video.src = url;
  // Load video in Safari / IE11
  video.muted = true;
  // video.playsInline = true

  return new Promise((resolve) => {
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      resolve(video.duration);
    };
  });
};

export const getThumbnailByHTMLVideoElement = async (
  video: HTMLVideoElement,
  height?: number
): Promise<string> => {
  const canvas = document.createElement('canvas');
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  if (height) {
    canvas.width = (height * video.videoWidth) / video.videoHeight;
    canvas.height = height;
  }
  canvas?.getContext('2d')?.drawImage(video, 0, 0, canvas.width, canvas.height);

  return new Promise((resolve) => {
    const dataUri = canvas.toDataURL();
    resolve(dataUri);
  });
};

export const getThumbnailsInBrowser = async (
  file: Blob,
  count: number
): Promise<string[]> => {
  const url = URL.createObjectURL(file);
  const video = document.createElement('video');
  video.preload = 'metadata';
  video.src = url;
  // Load video in Safari / IE11
  video.muted = true;
  // video.playsInline = true
  video.play();

  return new Promise((resolve) => {
    const images: string[] = [];
    let currentTime = 0;
    let step = 1;

    video.onloadeddata = () => {
      step = video.duration / count;
      video.currentTime = currentTime;
    };
    video.onseeked = async () => {
      const thumbnail = await getThumbnailByHTMLVideoElement(video, 48);
      images.push(thumbnail);

      currentTime += step;

      if (currentTime <= video.duration) {
        // this will trigger another seeked event
        video.currentTime = currentTime;
      } else {
        URL.revokeObjectURL(url);
        resolve(images);
      }
    };
  });
};

export const getCropInformation = (
  imageWidth: number,
  imageHeight: number,
  aspectRatio = 9 / 16
) => {
  let targetWidth = imageWidth;
  let targetHeight = imageWidth / aspectRatio;

  if (targetHeight > imageHeight) {
    targetHeight = imageHeight;
    targetWidth = imageHeight * aspectRatio;
  }

  const xOffset = (imageWidth - targetWidth) / 2;
  const yOffset = (imageHeight - targetHeight) / 2;

  return {
    width: targetWidth,
    height: targetHeight,
    x: xOffset,
    y: yOffset,
  };
};

export const createThumbnail = async (
  file: Blob,
  time = 0.0
): Promise<Blob> => {
  const url = URL.createObjectURL(file);
  const video = document.createElement('video');
  video.preload = 'metadata';
  video.src = url;
  // Load video in Safari / IE11
  video.muted = true;
  // video.playsInline = true;
  video.play();

  return new Promise((resolve) => {
    video.onloadeddata = () => {
      video.currentTime = time;
    };
    video.onseeked = async () => {
      video.pause();
      const thumbnail = await getThumbnailByHTMLVideoElement(video);
      URL.revokeObjectURL(url);
      const cropInformation = getCropInformation(
        video.videoWidth,
        video.videoHeight,
        9 / 16
      );
      const croppedImageBlob = await getCroppedImgFile(
        thumbnail,
        cropInformation
      );

      resolve(croppedImageBlob);
    };
  });
};
